<template>
    <v-dialog
        v-model="show"
        persistent
        max-width="600px"
    >
        <v-form v-model="validBillingPlan" lazy-validation>
        <v-card>
            <v-card-title>
            <span class="headline">{{$t('accountsAndBilling.billingPlan')}}</span>
            </v-card-title>
            <v-card-text>
            <v-container>
                <v-row>
                <v-col
                    cols="12"
                >
                    <v-text-field
                    :label="$t('accountsAndBilling.name')"
                    required
                    v-model="billingPlanEdited.name"
                    clearable
                    maxLength=50
                    :rules="nameRule"
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                <v-col
                    cols="12"
                >
                    <v-text-field
                    ref="billingFormula"
                    :label="$t('accountsAndBilling.billingFormula')"
                    required
                    v-model="billingPlan.billingFormula"
                    clearable
                    maxLength=200
                    :rules="formulaRule"
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                <v-col
                    cols="12"
                >
                    {{ $t('accountsAndBilling.keywords') }} 
                      <v-chip
                      v-for="keyword in keywords"
                      :key="keyword"
                      class="ma-2"
                      label
                      small
                      @click="billingPlan.billingFormula = [ billingPlan.billingFormula, keyword ].join(''); $refs.billingFormula.focus();"
                      >
                      {{ keyword }}
                      </v-chip>
                </v-col>
                </v-row>
                <v-row>
                <v-col cols="12">
                    <v-text-field
                    :label="$t('accountsAndBilling.requestUnitPrice')"
                    required
                    :rules="priceRules"
                    suffix="€"
                    v-model="billingPlan.requestUnitPrice"
                    @click:clear="billingPlan.requestUnitPrice=0;"
                    ></v-text-field>
                </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="blue darken-1"
                text
                @click="deleteBillingPlan(billingPlan)"
                :disabled="!billingPlan.id"
              >
                  {{ $t('global.delete') }}
              </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                :loading="isUpdatingBillingPlan"
                color="blue darken-1"
                text
                @click="createBillingPlan(billingPlan)"
                :disabled="!validBillingPlan"
            >
                {{ $t('global.save') }}
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="show = false"
            >
                {{ $t('global.cancel') }}
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-form>
    </v-dialog>
</template>


<script>
import billingPlanService from '@/services/billingPlans.js';

export default {
  name: 'BillingPlanDialog',

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    billingPlanEdited: {
      type: Object,
      required: true
    },
    saveCallback: {
      type: Function,
      required: true
    },
    deleteCallback: {
      type: Function,
      required: true
    }
  },

  computed: {
    show: {
        get () {
            return this.open;
        },
        set (value) {
            this.$emit('update:open', value);
        }
    },
    billingPlan: {
        get () {
            return this.billingPlanEdited;
        },
        set (value) {
            this.$emit('update:billingPlanEdited', value);
        }
    }
  },

  data () {
    return {
      keywords: ['NUMBER_OF_REQUESTS', 'REQUEST_UNIT_PRICE'],
      isUpdatingBillingPlan: false,
      isDeletingBillingPlan: false,
      validBillingPlan: false,
      priceRules: [
        v => !!v || this.$t('global.required'),
        v => parseFloat(v) > parseFloat(0.0) || this.$t('accountsAndBilling.priceMustBePositive')
      ],
      nameRule: [
        v => !!v || this.$t('global.required'),
        v => /.{1,50}/.test(v) || this.$t('accountsAndBilling.requireValidName'),
      ],
      formulaRule: [
        v => !!v || this.$t('global.required'),
        v => /.{1,200}/.test(v) || this.$t('accountsAndBilling.requireValidFormula'),
      ]
    }
  },

  methods: {
    createBillingPlan(billingPlan) {
      this.isUpdatingBillingPlan = true;
      billingPlanService.saveBillingPlan(billingPlan).then((res) => {
        this.saveCallback(res.data);
        this.$emit('raison-event', { type: 'success', messages: [this.$t('accountsAndBilling.billingPlanCreated', {billingPlanName: billingPlan.name})]});
      })
      .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] });
      }).finally(() => {
        this.show = false
        this.isUpdatingBillingPlan = false;
      });
    },

    deleteBillingPlan(billingPlan) {
      this.isDeletingBillingPlan = true;
      const that = this;
      billingPlanService.deleteBillingPlan(billingPlan.id).then(() => {
        that.deleteCallback();
        that.$emit('raison-event', { type:'success', messages: [this.$t('accountsAndBilling.billingPlanDeleted', {billingPlanName: billingPlan.name})] });
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages: [err]});
      }).finally(() => {
        that.show = false;
        that.isDeletingBillingPlan = false;
      });
    }

  },
};
</script>